import { Redirect, Route, Switch } from 'react-router';
import { useAppContext } from '../appProvider/contextProvider';
import PremiumComponent from '../components/PremiumFeatures/PremiumComponent';
import RouteConstant from './routeConstant';


const ProtectedRoutes = ({component: Component,role, userType, keyword, title, ...rest}) => {

    const token = localStorage.getItem('token');
    const user_id = localStorage.getItem('user_id');

    const { isFeatureAvailable } = useAppContext();

    const getComponent = (Component, props, keyword) => {

        if(keyword) {
            return isFeatureAvailable(keyword) ? <Component {...props} />
                : <PremiumComponent keyword={keyword} title={title} />
        }
        return <Component userKey={rest.userKey} {...props} />;
    }

    return <Route
    {...rest}
    render = {props =>
        !!token && !!user_id 
            ? getComponent(Component, {...props}, keyword)
            : <Redirect to={'/login'} />
        }
        />
};

const Routes = ({userKey}) => <Switch>
    {
        RouteConstant.map(
            ({path, role, userType ,component, keyword,title}, index) => <ProtectedRoutes 
                exact 
                path={path} 
                component={component} 
                key={index}
                role={role}
                userType={userType} 
                keyword={keyword}
                title={title}
                userKey={userKey}
            />)
    }
    <Route exact path = '/' render={() => <Redirect to='/dashboard' />} />
    <Route exact path = {'*'} render={() => <Redirect to='/dashboard' />} />
</Switch>


export default Routes;